import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TokenService } from 'src/app/shared/service/token.service';
import { menuDB } from 'src/app/shared/tables/menu';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-mega-menu',
  templateUrl: './mega-menu.component.html',
  styleUrls: ['./mega-menu.component.scss']
})
export class MegaMenuComponent implements OnInit {

  public menus = [];
  public selected = [];
  isDeleting = false;
  DeletingItem;
  MenuList;
  isLoading;

  constructor(private router: Router, private http: HttpClient, private toastr: ToastrService, private modalService: NgbModal, private TokenService: TokenService) {
    this.menus = menuDB.data;
    const a = JSON.parse(this.TokenService.getUser().Authority);
    if (!a['MegaMenu']) {
      router.navigateByUrl('/');
    }
  }

  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  ngOnInit() {
    this.GetMegaMenuList();
  }
  GetMegaMenuList() {
    this.http.get<any>(environment.url + 'Menu/GetMegaMenuAll').subscribe(data => {
      this.MenuList = data.Data;
      this.MenuList.sort((a, b) => {
        if (a['LanguageCode'] != null && b['LanguageCode'] != null) {
          if (a['LanguageCode'].toLowerCase() > b['LanguageCode'].toLowerCase()) {
            return -1;
          }
          if (b['LanguageCode'].toLowerCase() > a['LanguageCode'].toLowerCase()) {
            return 1;
          }
        }
        else {
          return 1;
        }
        return 0;
      });
      this.isLoading = true;
    });
  }

  gotoMegaMenuEdit(item: any) {
    const navigatioExtra: NavigationExtras = {
      queryParams: { id: item }
    }
    this.router.navigate(['/home/menus/edit-menu'], navigatioExtra);
  }

  DeleteMegaMenu() {
    this.isDeleting = true;
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        Ref: this.DeletingItem 
      },
    };
    this.http.delete<any>(environment.url + 'Menu/DeleteMegaMenu', options).subscribe(data => {
      this.isDeleting = false;
      this.DeletingItem = "";
      this.GetMegaMenuList();
      if (data.Success == true) {
        this.modalService.dismissAll();
        this.toastr.success("Mega Menü Silindi", '', {
          timeOut: 3000,
        });
      }
      else {
        this.toastr.error("Mega Menü Silinemedi", 'Hata !', {
          timeOut: 3000,
        });
      }
    });
  }
  DeleteMegaMenuModal(file,ref) {
    this.DeletingItem = ref;
    this.modalService.open(file, { centered: true });
  }
  CloseDeleteModalClose(){
    this.modalService.dismissAll();
    this.DeletingItem = "";
  }
}
